var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 45,
    viewBox: "0 0 47 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1531 33.4925V45H29.847V33.4904L39.8115 39.2452L46.1585 28.2527L36.1918 22.5L46.1585 16.7452L39.8115 5.7548L29.8449 11.5096V0H17.1551V11.5096L7.18851 5.7548L0.843638 16.7452L10.8082 22.5L0.841553 28.2548L7.18851 39.2452L17.1531 33.4925Z",
    fill: "#78E183"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.6f87a9d80dee3075f2fcbcc5050dc431.svg";
export { ForwardRef as ReactComponent };